<script>
    export let dealSettings;
    export let credits;
    export let month;

    $: state = getState(dealSettings, credits);
    $: tooltip = getTooltip(dealSettings, credits);

    function getState(dealSettings, credits) {
        if (credits.months[month].spent >= dealSettings.offers_per_month) {
            return "spent"
        } else if (credits.months[month].reserved + credits.months[month].spent >= dealSettings.offers_per_month) {
            return "reserved"
        }
        return "available"
    }

    function getTooltip(dealSettings, credits) {
        if (credits.months[month].spent >= dealSettings.offers_per_month) {
            return "Du hast alle deine Angebote für diesen Monat verbraucht."
        } else if (credits.months[month].reserved + credits.months[month].spent >= dealSettings.offers_per_month) {
            return `Du hast alle deine Angebote für diesen Monat verplant. Du kannst die geplanten Angebote aber noch löschen und stattdessen andere Angebote posten.`
        }
        return `Du hast noch ${dealSettings.offers_per_month - credits.months[month].reserved - credits.months[month].spent} Angebote für den Monat verfügbar.`
    }
</script>

<span class="credits {state}" title="{tooltip}">{dealSettings.offers_per_month - credits.months[month].reserved - credits.months[month].spent} von {dealSettings.offers_per_month}</span>

<style>
    .credits {
        font-weight: normal;
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: #E0D8D2;
        color: rgb(117, 107, 100);
        cursor: help;
    }

    .spent {
        background-color: rgb(255, 210, 210);
        color: rgb(210, 0, 0);
    }

    .reserved {
        background-color: rgb(255, 228, 140);
        color: #8b4513;
    }

    .available {
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
    }
</style>